






















import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class Document extends Vue {
  private links = [
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fdocument%2F1.png?alt=media&token=5768a994-ab75-4b7a-b9c2-8d6d5f174b05',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fdocument%2F2.png?alt=media&token=039e9553-563c-44e6-a6b5-e6e1f11f1991',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fdocument%2F3.png?alt=media&token=dc7027d3-a498-43ca-9d84-7a1021b9bed8',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fdocument%2F4.png?alt=media&token=7fc2dee0-defc-46c2-9a67-0925d75cb3bb',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fdocument%2F5.png?alt=media&token=06997865-67b1-4d0a-9857-493407fa1321',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fdocument%2F6.png?alt=media&token=ce77b67a-5b8f-4118-90fb-02e5a8a6e299',
    'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fdocument%2F7.png?alt=media&token=ea77cfda-9d2c-4292-8785-a505b3a2bdae',
  ];
}
